module.exports = __webpack_public_path__ + "img/iq.c3104587.svg";